
import { IRegistrationInfo, IRegistrationInfoData } from './registrationInfo.types'

/** class for registration */
export class RegistrationInfo implements IRegistrationInfo {

    readonly FullName: string
  
    readonly Position: string

    readonly Email: string
  
    readonly OrganizationName: string
  
    readonly OrganizationType: number

    readonly MemberID: string
  
    readonly EstablishedYear: number

    readonly Country: string
   
    readonly MailingAddress: string

    readonly PhysicalAddress: string

    readonly Telephone: string

    readonly Website: string

    PolicyAccepted:number

    PreferredLanguageId: number

    constructor (data: IRegistrationInfoData) {
    
        this.FullName = data.FullName
    
        this.Position = data.Position
    
        this.Email = data.Email
    
        this.OrganizationName = data.OrganizationName
    
        this.OrganizationType = data.OrganizationType

        this.MemberID = data.MemberID
    
        this.EstablishedYear = data.EstablishedYear

        this.MailingAddress = data.MailingAddress

        this.Country = data.Country

        this.PhysicalAddress = data.PhysicalAddress

        this.Telephone = data.Telephone

        this.Website = data.Website

        this.PolicyAccepted=data.PolicyAccepted

        this.PreferredLanguageId = data.PreferredLanguageId
    
    }

    /** method to write the custom validation */
    validate(): boolean {
        // To DO: write the actual logic here.
        return true
    }
}